import { createStyles, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';
import FsBodySmall from './FsBodySmall';

const FsBodySmallBold = withStyles(() =>
  createStyles({
    root: {
      fontWeight: 600,
    },
  })
)((props: TypographyAllProps) => <FsBodySmall {...props} />);

export default FsBodySmallBold;
